import { supabase } from '../supabase/client';

export const uploadImage = async file => {
  const fileExt = file.name.split('.').pop();
  const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
  const filePath = `${fileName}`;

  const { data: newFile, error } = await supabase.storage.from('images').upload(filePath, file);

  if (error) {
    throw error;
  }

  const {
    data: { publicUrl },
  } = await supabase.storage.from('images').getPublicUrl(filePath);

  return publicUrl;
};

export const uploadAudio = async file => {
  const fileExt = file.name.split('.').pop();
  const fileName = `${Math.random().toString(36).substring(2)}.${fileExt}`;
  const filePath = `${fileName}`;

  const { data, error } = await supabase.storage.from('audio').upload(filePath, file);

  if (error) {
    throw error;
  }

  const {
    data: { publicUrl },
  } = await supabase.storage.from('audio').getPublicUrl(filePath);

  return publicUrl;
};
